jQuery(function ($) {
  var flagByCountry = {
    US: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/7f0109d94c888a663452af48e2d324d7.svg',
    JP: 'https://cdn.shopify.com/static/images/flags/jp.svg',
    CA: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/422898ab4299eb270f856e6c1b8d2250.svg',
    GB: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/f9bbc4885a348eff84e4ef4155121fae.svg',
    AU: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/d4e9cde3edb3e1732ec50170e158d750.svg',
    BR: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/190073fb7652e7c635a1b91af0286b3c.svg',
    DK: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/e60c493fdbe69069d943ecc37287aa90.svg',
    MX: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/2bcda95713919c2134876a7da635da80.svg',
    NO: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/d8dd9ad33e2d0c876096fbdfd87bcf31.svg',
    NZ: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/cacb9f87701ae2707676064d036a97b2.svg',
    PL: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/965125896e906dc4ccbf65fa398c386c.svg',
    SE: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/637920f30b717c7f4e826a4bb63bb552.svg',
    CH: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/a5d4c82835e435ecff150a9a3426fed2.svg',
    AE: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/62a4257f72ece1437bc8eb7f0535327b.svg',
    AT: 'https://cdn.shopify.com/static/images/flags/at.svg',
    BE: 'https://cdn.shopify.com/static/images/flags/be.svg',
    DE: 'https://cdn.shopify.com/static/images/flags/de.svg',
    FI: 'https://cdn.shopify.com/static/images/flags/fi.svg',
    FR: 'https://cdn.shopify.com/static/images/flags/fr.svg',
    GR: 'https://cdn.shopify.com/static/images/flags/gr.svg',
    IE: 'https://cdn.shopify.com/static/images/flags/ie.svg',
    IT: 'https://cdn.shopify.com/static/images/flags/it.svg',
    NL: 'https://cdn.shopify.com/static/images/flags/nl.svg',
    PT: 'https://cdn.shopify.com/static/images/flags/pt.svg',
    ES: 'https://cdn.shopify.com/static/images/flags/es.svg'
  };

  var countryByCurrency = {
    USD: 'US',
    JPY: 'JP',
    CAD: 'CA',
    GBP: 'GB',
    AUD: 'AU',
    BRL: 'BR',
    DKK: 'DK',
    MXN: 'MX',
    NOK: 'NO',
    NZD: 'NZ',
    PLN: 'PL',
    SEK: 'SE',
    CHF: 'CH',
    AED: 'AE',
    EUR: 'DE'
  };

  function renderHeaderFlag(countryCode) {
    var flagUrl = flagByCountry[countryCode] || flagByCountry.US;
    $(".header_flag").html('<img src="' + flagUrl + '" alt="" role="presentation"/>');
  }

  function setHeaderFlagFromCurrency() {
    var currentCurrency = $('select.CurrencySelector__Select option:checked').val();
    renderHeaderFlag(countryByCurrency[currentCurrency] || 'US');
  }

  var testCountry = new URLSearchParams(window.location.search).get('test_country');
  var currentCountry = $('.header_flag').first().data('current-country');

  if (testCountry && flagByCountry[testCountry.toUpperCase()]) {
    renderHeaderFlag(testCountry.toUpperCase());
    return;
  }

  if (currentCountry && flagByCountry[String(currentCountry).toUpperCase()]) {
    renderHeaderFlag(String(currentCountry).toUpperCase());
    return;
  }

  if (window.Shopify && window.Shopify.routes) {
    fetch(
      window.Shopify.routes.root
        + 'browsing_context_suggestions.json'
        + '?country[enabled]=true'
        + `&country[exclude]=${window.Shopify.country}`
        + '&language[enabled]=true'
        + `&language[exclude]=${window.Shopify.language}`
    ).then(function (response) {
      return response.json();
    }).then(function (response) {
      var detectedCountry = response.detected_values.country.handle;

      if (flagByCountry[detectedCountry]) {
        renderHeaderFlag(detectedCountry);
        return;
      }

      setHeaderFlagFromCurrency();
    }).catch(setHeaderFlagFromCurrency);
    return;
  }

  setHeaderFlagFromCurrency();
});
